import React from "react";
import { X, PlayCircle } from "lucide-react";

interface AdminTrainingVideoModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const AdminTrainingVideoModal: React.FC<AdminTrainingVideoModalProps> = ({
    isOpen,
    onClose,
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal modal-open z-[100]">
            <div className="modal-box max-w-4xl p-0 overflow-hidden bg-black relative">
                <button
                    onClick={onClose}
                    className="btn btn-circle btn-sm absolute right-4 top-4 z-10 bg-white/20 hover:bg-white/40 border-none text-white"
                >
                    <X size={20} />
                </button>

                <div className="bg-emerald-900/50 p-6 pb-2">
                    <div className="flex items-center gap-3 text-white mb-2">
                        <PlayCircle className="text-emerald-400" />
                        <h3 className="text-xl font-bold italic">Admin Training Video</h3>
                    </div>
                    <p className="text-emerald-100/70 text-sm mb-4">
                        Exclusive guidance for Organisation Administrators
                    </p>
                </div>

                <div className="aspect-video w-full bg-slate-900 flex items-center justify-center">
                    <video
                        src="/videos/Admin Training Video 2026.mp4"
                        controls
                        autoPlay
                        className="w-full h-full"
                    >
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className="p-4 bg-emerald-900 border-t border-emerald-800 flex justify-end">
                    <button className="btn btn-primary btn-sm" onClick={onClose}>
                        Done
                    </button>
                </div>
            </div>
            <div className="modal-backdrop bg-black/80" onClick={onClose}></div>
        </div>
    );
};
